import React from 'react';

import { Card, Flex, Text } from '@opendoor/bricks/core';

import { customerDataProps } from '../../helpers/getAllParnLeadData';
import ParnLeadCardContent from './ParnLeadCardContent';

interface CustomerDetailsCardProps {
  isMobile: boolean;
  customerData?: customerDataProps;
  addressStreet: string;
  addressCity: string;
}

export const CustomerDetailsCard: React.FC<CustomerDetailsCardProps> = ({
  isMobile,
  customerData,
  addressStreet,
  addressCity,
}) => {
  return (
    <Card variant="secondary" boxShadow="unset" padding="25px 0px 35px 0px">
      <Text size={isMobile ? 's3' : 's4'} fontWeight={'semibold'} paddingBottom={'30px'}>
        Customer Details
      </Text>
      <Flex
        justifyContent="flex-start"
        style={{
          flexDirection: isMobile ? 'column' : 'row',
          display: 'flex',
        }}
      >
        <ParnLeadCardContent
          isMobile={isMobile}
          fieldName="Name"
          fieldValue1={customerData?.name}
          style={{ flex: 0.75, minWidth: '113px', marginRight: '10px' }}
        />
        <ParnLeadCardContent
          isMobile={isMobile}
          fieldName="Phone"
          fieldValue1={customerData?.phone}
          style={{ flex: 0.75, minWidth: '113px', marginRight: '5px' }}
        />
        <ParnLeadCardContent
          isMobile={isMobile}
          fieldName="Email"
          fieldValue1={customerData?.email}
          style={{ flex: 1, minWidth: '150px' }}
        />
        <ParnLeadCardContent
          isMobile={isMobile}
          fieldName="Address"
          fieldValue1={addressStreet}
          fieldValue2={addressCity}
          style={{ flex: 1, minWidth: '150px', marginRight: '5px' }}
        />
      </Flex>
    </Card>
  );
};
